export const LogoMark = ({ className = "w-9 h-9" }) => (
  <img src="/favicon.png" alt="Mister Pollo" className={`${className} rounded-xl object-cover`} />
);

export const LogoFull = ({ className = "" }) => (
  <img src="/images/logo.png" alt="Mister Pollo – Specialità allo spiedo dal 1998" className={`${className} object-contain`} />
);
